import ErrorIcon from 'assets/icons/error.png';
import styles from 'styles/pages/common/NotFound.module.scss';

const NotFound = () => {
  return (
    <div className={styles.wrapper}>
      <img src={ErrorIcon} alt="error" width={56} height={56} />
      <h1 className={styles.title}>404</h1>
      <p className={styles.text}>페이지를 찾을 수 없습니다.</p>
      <p className={styles.subtext}>해당 주소는 존재하지 않는 페이지입니다.</p>
      <p className={styles.subtext}>주소를 다시 한번 확인해 주세요.</p>
    </div>
  );
};

export default NotFound;
